import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { SITE_CONFIG } from "../../config/siteConfig";

export default function PageMeta({ title, description, path = "", breadcrumbs = [], noindex = false }) {
  const fullTitle = title ? `${title} | ${SITE_CONFIG.name}` : SITE_CONFIG.name;
  const url = `${SITE_CONFIG.url}${path}`;

  useEffect(() => {
    const scripts = [];

    if (breadcrumbs.length > 0) {
      const el = document.createElement("script");
      el.type = "application/ld+json";
      el.text = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": breadcrumbs.map((item, i) => ({
          "@type": "ListItem",
          "position": i + 1,
          "name": item.name,
          "item": `${SITE_CONFIG.url}${item.path}`,
        })),
      });
      document.head.appendChild(el);
      scripts.push(el);
    }

    // WebSite / Organization の JSON-LD は public/index.html に静的に記載済み

    // クリーンアップ（ページ遷移時に削除）
    return () => {
      scripts.forEach((el) => document.head.removeChild(el));
    };
  }, [title, breadcrumbs]);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={SITE_CONFIG.ogpImage} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_CONFIG.name} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={SITE_CONFIG.ogpImage} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex" />}
    </Helmet>
  );
}